import { render, staticRenderFns } from "./MiniCartItem.vue?vue&type=template&id=b6f7aad6&"
import script from "./MiniCartItem.vue?vue&type=script&lang=js&"
export * from "./MiniCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports